// extracted by mini-css-extract-plugin
module.exports = {"external-resources-wrapper":"ExternalResources_external-resources-wrapper__yRiko"};